<template>
  <div>
    <div class="card top-draft">
      <div class="col-lg-12 list-header mg-top-1 pad-header-bg clearfix">
        <div class="app-list-sort header-item-fix">
          <b-dropdown>
            <template v-slot:button-content>
              <sort-icon />
            </template>
            <b-dropdown-item
              v-for="(item, index) in sortList"
              :key="index"
              @click="listSort(item)"
            >
              <span class="pull-left" v-if="pageParams.sortBy == item.value">
                <i
                  v-if="pageParams.order == 'desc'"
                  class="bx bx-down-arrow-alt font-size-18 pull-left"
                ></i>
                <i
                  v-if="pageParams.order == 'asc'"
                  class="bx bx-up-arrow-alt font-size-18"
                ></i>
              </span>
              <span :class="{ padleft: pageParams.sortBy != item.value }">{{
                item.text
              }}</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="header-item-fix">
          <b-form-input
            size="sm"
            type="text"
            v-model="pageParams.contentKeyword"
            placeholder="请输入搜索内容"
          ></b-form-input>
          <b-button size="sm" variant="primary" @click="search()">
            <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
            搜索
          </b-button>
          <b-button
            size="sm"
            variant="outline-secondary"
            @click="resetParams()"
          >
            <i class="bx bx-revision font-size-16 align-middle"></i>
            重置
          </b-button>
        </div>
        <div class="header-item-fix">
          <el-select
            v-model="currentTag"
            @change="selectTags()"
            filterable
            multiple
            placeholder="筛选标签"
          >
            <template>
              <el-input
                v-model="searchTagName"
                placeholder="输入标签名字搜索"
                style="width: 90%; margin-left: 5%"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="tagSearch"
                ></el-button>
              </el-input>
            </template>

            <el-option
              v-for="item in searchTagList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="col-lg-12">
        <el-table
          v-loading="tableLoading"
          :data="items"
          style="width: 100%"
          :stripe="true"
          @selection-change="tableSelectionChange"
        >
          <el-table-column
            fixed="left"
            type="selection"
            align="center"
            width="30"
          >
          </el-table-column>
          <el-table-column label="ID" prop="id" width="60" fixed="left">
          </el-table-column>
          <el-table-column label="标题" min-width="200" fixed="left">
            <template slot-scope="item">
              <div>
                <span>{{ item.row.title }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="封面" width="120">
            <template slot-scope="item">
              <img
                v-if="item.row.image"
                class="w-3-rem"
                :src="`${item.row.image}`"
                alt
              />
              <img
                v-if="!item.row.image"
                class="w-3-rem"
                src="@/assets/images/image-null.jpg"
                alt=""
              />
            </template>
          </el-table-column>
          <el-table-column label="标签" width="80">
            <template slot-scope="item">
              <el-tooltip class="item" effect="dark" placement="top-start">
                <div style="max-width: 400px" slot="content">
                  {{ item.row.tagName || "--" }}
                </div>
                <div>
                  {{
                    item.row.tagName.length > 34
                      ? item.row.tagName.substring(0, 34) + "..."
                      : item.row.tagName || "--"
                  }}
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="发布日期" width="152" prop="publishedAt">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="165">
            <template slot-scope="item">
              <div style="display: flex; flex-wrap: wrap">
                <div style="padding: 5px 0">
                  <button
                    v-if="power['编辑信息']"
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toDetail(item.row, 'isModify')"
                  >
                    编辑信息
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <button
                    v-if="power['编辑详情']"
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="toDetail(item.row)"
                  >
                    编辑详情
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <button
                    type="button"
                    class="btn-sm btn btn-primary m-r-10"
                    @click="batchPublish(item.row)"
                  >
                    发布
                  </button>
                </div>
                <div style="padding: 5px 0">
                  <button
                    v-if="power['移除']"
                    type="button"
                    class="btn-sm btn btn-danger"
                    @click="remove(item.row)"
                  >
                    移除
                  </button>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- :isBatch 如果有批量操作就传这个参数 没有就不传
        batchs 批量操作的列表
        pageCallback 分页组件的回调方法 -->
        <pagination
          :isBatch="true"
          :batchs="batchs"
          ref="page"
          @pageCallback="pageCallback"
        ></pagination>
        <media-dialog ref="media" @pageCallback="pageCallback"></media-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import article from "@/server/api/article";
import mediaDialog from "./mediaDialog";
import tags from "@/server/api/tags";
import { uniqueId } from "lodash";
import { getPreLink, copyLink, getCopyLink } from "@/util/fun.js";
/**
 * Contacts-list component
 */
export default {
  components: {
    mediaDialog,
  },
  data() {
    return {
      power: "",
      choiceListIds: [], //当前所选择的id
      pageParams: {
        page: 1,
        pageSize: 30,
        type: 1, // 0:草稿，1:初遍池，2：文章列表
        sortBy: "",
        order: "",
        contentKeyword: "",
        mediaId: undefined,
      },
      currentTag: "",
      items: [],
      sortList: [
        { text: "阅读", value: "viewNum" },
        { text: "评论", value: "commentNum" },
        { text: "日期", value: "createTime" },
      ],
      batchs: [
        //批量操作有哪些操作
        { text: "批量操作", value: "0" },
        { text: "移除", value: "1" },
        { text: "发布", value: "2" },
        // { text: "修改媒体号", value: "3" },
      ],
      searchTagName: "",
      searchTagList: [],
      tableLoading: false,
    };
  },
  mounted() {
    this.pageParams.mediaId = JSON.parse(localStorage.chosedMedia).id;
    console.log("媒体号id", this.pageParams.mediaId);
    this.getList();
    // this.power = this.utils.currentPower("内容-文章");
    // this.batchs = this.utils.currentBatchs(this.batchs, this.power);
    this.tagSearch();
  },

  created() {},

  methods: {
    tableSelectionChange(selectValues) {
      this.choiceListIds = [];
      selectValues.map((val) => {
        this.choiceListIds.push(val.id);
      });
    },
    //获取列表数据
    getList() {
      let params = this.another(this.pageParams);
      this.cleanObj(params);
      this.items = [];
      this.choiceListIds = [];
      // this.$refs.loading.show();
      this.tableLoading = true;
      article.list(params).then((resp) => {
        if (resp.data) {
          this.tableLoading = false;
          if (resp.data.items) {
            this.items = resp.data.items;
            let pages = {
              page: resp.data.page, //第几页
              pageSize: resp.data.pageSize, //每页多少条
              total: resp.data.total, //全部有多少条数据
              totalPages: resp.data.totalPages, //全部有几页
            };
            // 获取列表后调用组件的方法传入分页信息
            this.$nextTick(() => {
              if (this.$refs.page) {
                this.$refs.page.setPages(pages);
              }
            });
          }
        }
      });
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "pageSize") {
        if (obj.ps == 100) {
          this.pageParams.pageSize = 100;
          this.getList();
        } else if (obj.ps == 50) {
          this.pageParams.pageSize = 50;
          this.getList();
        } else {
          this.pageParams.pageSize = 30;
          this.getList();
        }
      }
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      if (obj.code === "media") {
        this.getList();
      }
      if (obj.code === "batch") {
        //处理批量操作
        console.log(this.choiceListIds, "批量的id");
        if (obj.batch == 1) {
          if (this.choiceListIds.length) {
            //点击移除的处理方法
            this.remove();
          } else {
            Vue.swal("请选择要移除的内容");
            return;
          }
        }
        if (obj.batch == 2) {
          if (this.choiceListIds.length) {
            //点击发布的处理方法
            this.batchPublish();
          } else {
            Vue.swal("请选择要发布的内容");
            return;
          }
        }
        if (obj.batch == 3) {
          if (this.choiceListIds.length) {
            //点击修改媒体号的处理方法
            this.$refs.media.showModel(this.choiceListIds, "article");
          } else {
            Vue.swal("请选择要修改的内容");
            return;
          }
        }
      }
    },

    //添加
    toCreate() {
      this.$router.push({
        name: "articleDetail",
      });
    },

    //去编辑
    toDetail(item, isModify) {
      if (isModify) {
        this.$router.push({
          name: "articleDetail",
          query: { id: item.id, isModify: true },
        });
      } else {
        this.$router.push({
          name: "articleDetail",
          query: { id: item.id },
        });
      }
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.contentKeyword = "";
      this.pageParams.tagId = "";
      this.pageParams.sortBy = "";
      this.pageParams.order = "";
      this.currentTag = [];
      this.getList();
    },

    selectTags() {
      this.pageParams.tagId = this.currentTag.toString();
      this.getList();
    },

    // 排序
    listSort(item) {
      if (this.pageParams.sortBy == item.value) {
        this.pageParams.sortBy = item.value;
        if (this.pageParams.order == "asc") {
          this.pageParams.order = "desc";
        } else {
          this.pageParams.order = "asc";
        }
      } else {
        this.pageParams.sortBy = item.value;
        this.pageParams.order = "desc"; //默认倒序
      }
      this.getList();
    },

    batchPublish(item) {
      Swal.fire({
        title: "确定发布?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "发布",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          article.publish(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "发布成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },

    batchHide(item) {
      Swal.fire({
        title: "确定隐藏?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "隐藏",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          article.hide(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "隐藏成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },

    batchShow(item) {
      Swal.fire({
        title: "确定显示?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "显示",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          article.show(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "显示成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },

    remove(item) {
      Swal.fire({
        title: "确定删除?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          console.log("移除参数", params);
          article.remove(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "删除成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },
    //标签搜索
    tagSearch() {
      let params = {
        page: 1,
        pageSize: 20,
        type: 0, // 0内容标签  1用户标签
        name: this.searchTagName, // 非必需，搜索的时候用
      };
      tags.list(params).then((resp) => {
        console.log(resp);
        if (resp.data) {
          if (resp.data.items[0]) {
            this.searchTagList = resp.data.items;
          } else {
            Vue.swal({
              icon: "warning",
              title: "未搜索到相关标签，请重新输入！",
              showConfirmButton: false,
              timer: 1000,
            });
          }
        }
      });
    },
  },
};
</script>
<style scoped>
::v-deep .el-table thead .el-table__cell:first-child .cell {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
::v-deep .el-table tbody > .el-table__row .el-table__cell:first-child .cell {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
::v-deep .el-table thead .el-table__cell:first-child .cell .el-checkbox {
  margin-bottom: 0 !important;
}
::v-deep
  .el-table
  tbody
  > .el-table__row
  .el-table__cell:first-child
  .cell
  .el-checkbox {
  margin-bottom: 0 !important;
}
::v-deep .el-table thead .el-table__cell:nth-child(2) .cell {
  padding-left: 0px !important;
}
::v-deep .el-table tbody > .el-table__row .el-table__cell:nth-child(2) .cell {
  padding-left: 0px !important;
}
::v-deep .el-table tbody > .el-table__row .el-table__cell:last-child .cell {
  padding-right: 0px !important;
}
</style>
